var keyMirror = require('keymirror');

module.exports = keyMirror({
    SEARCH_WORKSPACE: null,
    SEARCH_WORKSPACE_NAME:null,
    CREATE_WORKSPACE:null
})